export const useStyles = (theme) => ({
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up(960)]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "none",
    [theme.breakpoints.down(960)]: {
      display: "flex",
    },
  },
  root: {
    color: "#fff",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  selectedStyle: {
    color: "#ffd31a",
  },
  navStyle: {
    fontWeight: "bolder",
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    fontWeight: "bolder",
  },
});
